import React, { useState } from "react";
import DimonShapes from "./DimonShapes";
import ColorTab from "./Color/ColorTab";
import Carat from "./Carat";
import Price from "./Price";
import Clarity from "./Clarity";
import Lab from "./Lab";
import CutPolSym from "./CutPolSym";
import FromToRangeInput from "../input/FromToRangeInput";
import Measurement from "./Measurement/Measurement";
import Fluorescent from "./Fluorescent";
import Culet from "./Culet";
import Girdle from "./Girdle";
import { updateFilter } from "../../store/slices/filterSlice";
import { useDispatch, useSelector } from "react-redux";
import Location from "./Location";
import CertificateNumber from "./CertificateNumber";
import IcDoubleUpArrow from "../../assets/icons/IcDoubleUpArrow";

const GlobalFilter = () => {
  const filterSelect = useSelector((state) => state?.filter);
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(true);
  return (
    <div className="container global-filter-container mt-md-5">
      <DimonShapes />
      <div className="mt-4">
        <ColorTab />
        <Carat />
      </div>
      <Price />
      <div className="d-flex mt-3 gap-3 clarity-lab-container">
        <Clarity />
        <Lab />
      </div>
      <div className="mt-3">
        <CutPolSym />
      </div>
      <div className="mt-3 d-flex gap-3 depth-table-container">
        <FromToRangeInput
          mainLabel={"Depth(%)"}
          mainContainerClass="w-100"
          innerContainerClass={"w-100"}
          fromValue={filterSelect?.minDepthPercentage}
          toValue={filterSelect?.maxDepthPercentage}
          onMinChange={(e) =>
            dispatch(
              updateFilter({
                key: "minDepthPercentage",
                value: Number(e.target.value),
              })
            )
          }
          onMaxChange={(e) =>
            dispatch(
              updateFilter({
                key: "maxDepthPercentage",
                value: Number(e.target.value),
              })
            )
          }
        />
        <FromToRangeInput
          mainLabel={"Table(%)"}
          mainContainerClass="w-100"
          innerContainerClass={"w-100"}
          fromValue={filterSelect?.minTablePercentage}
          toValue={filterSelect?.maxTablePercentage}
          onMinChange={(e) =>
            dispatch(
              updateFilter({
                key: "minTablePercentage",
                value: Number(e.target.value),
              })
            )
          }
          onMaxChange={(e) =>
            dispatch(
              updateFilter({
                key: "maxTablePercentage",
                value: Number(e.target.value),
              })
            )
          }
        />
      </div>
      <div className="expandable-container ">
        <div
          className={`expandable-container-inner ${
            expanded ? "expanded" : "collaps"
          }`}
        >
          <Measurement />
          <div className="mt-3 d-flex gap-3 fluorescent-culet-container">
            <Fluorescent />
            <Culet />
          </div>
          {/* <Girdle /> */}
          <Location />
          <CertificateNumber />
        </div>
        <div
          className={`expand-button ${expanded ? "rotate" : ""}`}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "More Filters" : "Show Less"}
          <IcDoubleUpArrow />
        </div>
      </div>
    </div>
  );
};

export default GlobalFilter;
